import { OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { UiService } from '../ui/ui.service';
import { ZevensterStateService } from '../zevenster-state/zevenster-state.service';
import { Router } from '@angular/router';
import { ZevensterAjaxService } from '../zevenster-ajax/zevenster-ajax.service';
import { from } from 'rxjs';
var ZevensterCheckoutPageComponent = /** @class */ (function () {
    function ZevensterCheckoutPageComponent(ui, zevensterStateService, zevensterAjaxService, router) {
        this.ui = ui;
        this.zevensterStateService = zevensterStateService;
        this.zevensterAjaxService = zevensterAjaxService;
        this.router = router;
        this.isDonation = false;
        this.isInNameOfCompany = false;
    }
    ZevensterCheckoutPageComponent.prototype.ngOnInit = function () {
        var purchase = this.zevensterStateService.purchase;
        if (!purchase || !purchase.fields.areas.length) {
            this.router.navigateByUrl('/zevensterbos');
        }
        else {
            this.purchase = purchase;
            this.focusedSquare$ = from(purchase.fields.areas);
        }
    };
    ZevensterCheckoutPageComponent.prototype.ngAfterViewInit = function () {
        this.ui.whitened$.next(true);
    };
    ZevensterCheckoutPageComponent.prototype.ngOnDestroy = function () {
        this.ui.whitened$.next(false);
    };
    ZevensterCheckoutPageComponent.prototype.onSubmit = function () {
        this.zevensterAjaxService.postAndPay(this.purchase);
    };
    return ZevensterCheckoutPageComponent;
}());
export { ZevensterCheckoutPageComponent };
//# sourceMappingURL=zevenster-checkout-page.component.js.map